import React from 'react';

const LoadingScreenContext = React.createContext({
    loading: undefined,
    setLoading: () => {},
});

LoadingScreenContext.displayName = 'LoadingScreenContext';

export default LoadingScreenContext;
